import React from "react";
import { Link } from "react-router-dom";

const BreadcrumbImage = ({
  heading = "Become A Fun Card Vendor",
  subtext = "18 Years of Coupon Deals, 10,000+ Happy Customers.",
  buttonText = "Create A Vendor Account",
  buttonLink = "/vendor-login",
  accent = null,
}) => {
  return (
    <section
      className='banner-inner z-1 position-relative py-72'
      style={{ backgroundColor: '#121535', overflow: 'hidden' }}
    >
      <div className='banner-inner__img position-absolute inset-inline-end-0 top-50 translate-middle-y h-100 arrow-left-clip w-30-percent d-xxl-block d-none'>
        {/* <img
          src='assets/images/thumbs/banner-inner-img.png'
          alt=''
          className='h-100'
        /> */}
      </div>

      {/* Teal strip on the left with a dark < notch cut into its right edge */}
      {accent === 'left' && (
        <div style={{
          position: 'absolute',
          inset: 0,
          background: '#87C1BB',
          clipPath: 'polygon(0 0, 260px 0, 130px 50%, 260px 100%, 0 100%)',
          zIndex: 0,
        }} />
      )}

      {/* Teal strip on the right with a dark > notch cut into its left edge */}
      {accent === 'right' && (
        <div style={{
          position: 'absolute',
          inset: 0,
          background: '#87C1BB',
          clipPath: 'polygon(100% 0, calc(100% - 260px) 0, calc(100% - 130px) 50%, calc(100% - 260px) 100%, 100% 100%)',
          zIndex: 0,
        }} />
      )}

      <div className='container' style={{ position: 'relative', zIndex: 1 }}>
        <div className='banner-inner__content text-center'>
          <h4 className='text-white mb-20 fw-semibold'>
            {heading}
          </h4>
          <p className='text-white my-20'>
            {subtext}
          </p>
          <Link to={buttonLink} className='btn btn-main-two rounded-8'>
            {buttonText}
          </Link>
        </div>
      </div>
    </section>
  );
};

export default BreadcrumbImage;
